import React, { useState } from 'react';
import { Box, styled } from '@mui/material';
import { Link } from 'react-router-dom';
import { BlagoomStandardLogo } from '../../icons/icons-svg/blagoom-standard-logo';
import { CentralNavigationBar } from './central-navigation-bar';
import { NotificationsButton } from './notifications/notifications-button';
import { NotificationsMenu } from './notifications/notifications-menu';
import { ProfileButton } from './profile-button';
import { LoginButton } from './login-button';
import { useClearNotificationsCount } from '../../../hooks/useHeaderNotifications';

const TopWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isOnLandingPage'
})(({ theme, isOnLandingPage }) => ({
  width: "100%",
  position: "fixed",
  top: 0,
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  backgroundColor: isOnLandingPage ? "transparent" : "#ffffff",
  zIndex: 8,
}));

const LeftWrapper = styled(Box)(({ theme }) => ({
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  paddingLeft: "10px",
  marginTop: "-10px",
  [`@media only screen and (max-width: ${theme.firstBreakpoint}px)`]: {
    width: "100px",
    marginTop: "0px",
    alignItems: "center",
  },
}));

const StyledBlagoomStandardLogo = styled(BlagoomStandardLogo)(({ theme }) => ({
  margin: "20px 5px",
  width: "150px",
  [`@media only screen and (max-width: ${theme.firstBreakpoint}px)`]: {
    margin: "10px 5px",
    width: "90px",
  },
}));

const HideOnMobileBox = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  [`@media only screen and (max-width: ${theme.firstBreakpoint}px)`]: {
    display: "none",
  },
}));

const RightWrapperMobileFiller = styled(Box)(({ theme }) => ({
  width: "50px",
  [`@media only screen and (min-width: ${theme.firstBreakpoint + 1}px)`]: {
    display: "none",
  },
}));

const RightWrapperWeb = styled(Box)(({ theme }) => ({
  height: "100%",
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  marginTop: "-20px",
  [`@media only screen and (max-width: ${theme.firstBreakpoint}px)`]: {
    marginTop: "0px",
    alignItems: "center",
  },
}));

const ProfileOrLoginDropdownWrapper = styled(Box)({
  position: "relative",
});

export const HeaderTopSection = ({
  isOnLandingPage,
  hideNavigation,
  isLoggedIn,
  loadingUserData,
  getUserError,
  userData,
  profileProps,
  position,
  props,
}) => {
  // Notifications state
  const [notificationsAnchorEl, setNotificationsAnchorEl] = useState(null);
  const [isEmailMenuOpen, setIsEmailMenuOpen] = useState(false);
  const isNotificationsMenuOpen = Boolean(notificationsAnchorEl);
  const clearNotificationsCount = useClearNotificationsCount(userData);

  const handleBellClick = (event) => {
    if (!isNotificationsMenuOpen) {
      setNotificationsAnchorEl(event.currentTarget);
      // Clear notifications count without blocking UI
      clearNotificationsCount().catch(() => {
        // Silently handle errors
      });
    } else {
      setNotificationsAnchorEl(null);
    }
    if (isEmailMenuOpen) {
      setIsEmailMenuOpen(false);
    }
  };

  const handleNotificationsClose = () => {
    setNotificationsAnchorEl(null);
    setIsEmailMenuOpen(false);
  };

  return (
    <TopWrapper isOnLandingPage={isOnLandingPage}>
      <LeftWrapper>
        <Link to={"/"} style={{ textDecoration: "none" }}>
          <StyledBlagoomStandardLogo color={props?.color} />
        </Link>
      </LeftWrapper>

      <HideOnMobileBox>
        {!hideNavigation && <CentralNavigationBar />}
      </HideOnMobileBox>

      <RightWrapperMobileFiller />
      
      <RightWrapperWeb id="header_right_wrapper">
        {isLoggedIn && !loadingUserData && !getUserError && (
          <>
            <NotificationsButton
              notificationsCount={userData.user.newNotificationsCount}
              onClick={handleBellClick}
              size={17}
            />
            <NotificationsMenu
              anchorEl={notificationsAnchorEl}
              open={isNotificationsMenuOpen}
              onClose={handleNotificationsClose}
              isEmailMenuOpen={isEmailMenuOpen}
              setIsEmailMenuOpen={setIsEmailMenuOpen}
              setIsNotificationsMenuOpen={(value) => {
                if (!value) {
                  setNotificationsAnchorEl(null);
                }
              }}
            />
            <ProfileOrLoginDropdownWrapper ref={profileProps.wrapperRefDropdown}>
              <ProfileButton getUserData={userData} />
            </ProfileOrLoginDropdownWrapper>
          </>
        )}
      </RightWrapperWeb>
      {!isLoggedIn && <LoginButton position={position} props={props} />}
    </TopWrapper>
  );
};
